export const avtalegiroInitialState = {
    toAccount: undefined,
    fromAccount: undefined,
    kid: undefined,
    transactionLimit: 0,
    monthlyLimit: 0,
    notification: false,
    note: '',
    showFromAccounts: false,
};
export const getInitialState = (avtalegiro, toAccount) => ({
    showFromAccounts: false,
    notification: false,
    transactionLimit: avtalegiro.limits?.transaction ?? 0,
    monthlyLimit: avtalegiro.limits?.monthly ?? 0,
    kid: avtalegiro.kid,
    fromAccount: avtalegiro.fromAccountNumber,
    toAccount: toAccount ?? { accountNumber: avtalegiro.toAccount },
    note: avtalegiro.ownText,
});
export const getProposalState = (avtalegiroProposal) => ({
    showFromAccounts: false,
    notification: false,
    transactionLimit: 0,
    monthlyLimit: 0,
    kid: avtalegiroProposal.proposal.kid,
    fromAccount: avtalegiroProposal.proposal.fromAccount,
    toAccount: { accountNumber: avtalegiroProposal.proposal.toAccountNumber },
    note: undefined,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy90cmFuc2FjdGlvbi9BdnRhbGVHaXJvL2Zvcm0vc3RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBY0EsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQW9CO0lBQ25ELFNBQVMsRUFBRSxTQUFTO0lBQ3BCLFdBQVcsRUFBRSxTQUFTO0lBQ3RCLEdBQUcsRUFBRSxTQUFTO0lBQ2QsZ0JBQWdCLEVBQUUsQ0FBQztJQUNuQixZQUFZLEVBQUUsQ0FBQztJQUNmLFlBQVksRUFBRSxLQUFLO0lBQ25CLElBQUksRUFBRSxFQUFFO0lBQ1IsZ0JBQWdCLEVBQUUsS0FBSztDQUMxQixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLENBQzNCLFVBQXNDLEVBQ3RDLFNBQXVDLEVBQ3hCLEVBQUUsQ0FBQyxDQUFDO0lBQ25CLGdCQUFnQixFQUFFLEtBQUs7SUFDdkIsWUFBWSxFQUFFLEtBQUs7SUFDbkIsZ0JBQWdCLEVBQUUsVUFBVSxDQUFDLE1BQU0sRUFBRSxXQUFXLElBQUksQ0FBQztJQUNyRCxZQUFZLEVBQUUsVUFBVSxDQUFDLE1BQU0sRUFBRSxPQUFPLElBQUksQ0FBQztJQUM3QyxHQUFHLEVBQUUsVUFBVSxDQUFDLEdBQUc7SUFDbkIsV0FBVyxFQUFFLFVBQVUsQ0FBQyxpQkFBaUI7SUFDekMsU0FBUyxFQUFFLFNBQVMsSUFBSSxFQUFFLGFBQWEsRUFBRSxVQUFVLENBQUMsU0FBUyxFQUFFO0lBQy9ELElBQUksRUFBRSxVQUFVLENBQUMsT0FBTztDQUMzQixDQUFDLENBQUM7QUFFSCxNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLGtCQUFzQyxFQUFtQixFQUFFLENBQUMsQ0FBQztJQUMxRixnQkFBZ0IsRUFBRSxLQUFLO0lBQ3ZCLFlBQVksRUFBRSxLQUFLO0lBQ25CLGdCQUFnQixFQUFFLENBQUM7SUFDbkIsWUFBWSxFQUFFLENBQUM7SUFDZixHQUFHLEVBQUUsa0JBQWtCLENBQUMsUUFBUSxDQUFDLEdBQUc7SUFDcEMsV0FBVyxFQUFFLGtCQUFrQixDQUFDLFFBQVEsQ0FBQyxXQUFXO0lBQ3BELFNBQVMsRUFBRSxFQUFFLGFBQWEsRUFBRSxrQkFBa0IsQ0FBQyxRQUFRLENBQUMsZUFBZSxFQUFFO0lBQ3pFLElBQUksRUFBRSxTQUFTO0NBQ2xCLENBQUMsQ0FBQyJ9